import { render, staticRenderFns } from "./StatementVIew.vue?vue&type=template&id=3be940d7"
import script from "./StatementVIew.vue?vue&type=script&lang=js"
export * from "./StatementVIew.vue?vue&type=script&lang=js"
import style0 from "./StatementVIew.vue?vue&type=style&index=0&id=3be940d7&prod&lang=css"
import style1 from "./StatementVIew.vue?vue&type=style&index=1&id=3be940d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports